import React, { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { useNavigate } from "react-router-dom";
import { StatusBadge } from "@/components/StatusBadge";
import { URGENCY_LABELS, URGENCY_STYLES, fmtDateShort } from "@/lib/constants";
import { CheckSquare } from "lucide-react";

export default function Approval() {
  const navigate = useNavigate();
  const [reports, setReports] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api
      .get("/reports", { params: { status: "menunggu_persetujuan" } })
      .then(({ data }) => setReports(Array.isArray(data) ? data : data.items || []))
      .catch(() => setReports([]))
      .finally(() => setLoading(false));
  }, []);

  return (
    <div className="space-y-6">
      <div>
        <h1 className="font-display text-4xl font-extrabold tracking-tight text-slate-900 md:text-5xl">
          Persetujuan Laporan
        </h1>
        <p className="mt-1 text-sm text-slate-500">
          Laporan yang menunggu keputusan Anda. Klik untuk melihat detail & menyetujui / menolak.
        </p>
      </div>

      {loading ? (
        <p className="text-sm text-slate-400">Memuat…</p>
      ) : reports.length === 0 ? (
        <div className="rounded-md border border-slate-200 bg-white p-14 text-center shadow-sm">
          <CheckSquare className="mx-auto h-8 w-8 text-slate-300" />
          <p className="mt-2 text-sm text-slate-400">Tidak ada laporan menunggu persetujuan.</p>
        </div>
      ) : (
        <div className="grid grid-cols-1 gap-4 md:grid-cols-2">
          {reports.map((r) => (
            <button
              key={r.id}
              data-testid={`approval-card-${r.id}`}
              onClick={() => navigate(`/reports/${r.id}`)}
              className="rounded-md border border-slate-200 bg-white p-5 text-left shadow-sm transition-colors hover:bg-slate-50"
            >
              <div className="flex items-center justify-between">
                <span className="font-medium text-[var(--sipkd-primary)]">{r.report_number}</span>
                <span
                  className={`rounded-md border px-2 py-0.5 text-xs font-semibold ${URGENCY_STYLES[r.urgency]}`}
                >
                  {URGENCY_LABELS[r.urgency]}
                </span>
              </div>
              <p className="mt-2 font-num text-lg font-bold text-slate-900">{r.plate_number}</p>
              <p className="mt-1 line-clamp-2 text-sm text-slate-600">{r.damage_description}</p>
              <div className="mt-3 flex items-center justify-between text-xs text-slate-400">
                <span>{r.reporter_name} • {r.division_name || "-"}</span>
                <span>{fmtDateShort(r.created_at)}</span>
              </div>
            </button>
          ))}
        </div>
      )}
    </div>
  );
}
